
import React from 'react';
import '../assets/styles/AboutPage.css'; // Adjust the path as necessary
const AboutPage = () => {
  return (
    <div>
      <main>
        <section className="about-header">
            <h2>Hola, I'm Bob</h2>
            <p>
              I break things for fun and fix them for profit. <br /> 
              Former psychology student turned byte enthusiast. <br /> 
              If it plugs in, I can probably pop a shell on it.
            </p>
        </section>

        <section className="about-intro">
            <h3>Background</h3>
            <p>
              From psychology labs to packet captures—my path has been weird, winding, and wildly worth it. I started in Psychology, studying how behavior is shaped, manipulated, and sometimes exploited. That foundation gave me an edge in understanding human error and vulnerabilities—perfectly transferable to cybersecurity.
            </p>
            <p>
              These days, I’m deep into Security+, hunting flags on TryHackMe &amp; HTB, and building tools no one asked for. I like breaking things ethically, finding the cracks, and learning how to prevent them from happening again.
            </p>
        </section>

        <section className="about-content">
            <h3>My Toolbox</h3>
            <p>
              Wireshark, Burp Suite, Nmap, Metasploit, Python, Bash... and the occasional roll of duct tape. If it's a tool that can tear apart packets, pop shells, or scrape sensitive info, it's probably got a place in my workflow.
            </p>
            <p>
              Currently experimenting with OSINT tools and reverse engineering to level up the game even further. Got a project? I’m probably already building something like it for fun.
            </p>
        </section>

        <section className="about-content">
            <h3>Why the Name?</h3>
            <p>If you know, well you know...</p>
        </section>
        
        <section className="web-page">
            <h3>Under Construction (Kinda, Sorta... Forever)</h3>
            <p>
              This site is hand-built and probably a bit chaotic—kinda like me. If something breaks...well, let's call it a feature until I get around to fixing it. Consider it part of the charm.
            </p>
        </section>

        <section className="about-quote">
            <p>"If you aren't breaking it, you aren't learning it."</p>
        </section>
      </main>
    </div>
  );
};

export default AboutPage;